<template>
<button :disabled="disable"
		:class="style()"
		>
	<slot />
</button>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
	name: 'BasicButton',
	props: {
		disable: {
			type: Boolean,
			default: false,
		},
		toggled: {
			type: Boolean,
			default: false,
		},
    stretch: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String as PropType<'btn-md' | 'btn-lg'>,
      default: 'btn-md',
    },
    border: {
      type: Boolean,
      default: false,
    }
	},
  computed: {
    borderStyle(): string {
      return this.$props.border ? 'preset-outlined-surface-500' : '';
    }
  },
	mounted() {
		if (this.toggled) {
			//this.$el.focus();
		}
	},
	methods: {
		style() {
			let base = `btn ${this.size} transition-colors ` +
			'hover:preset-filled-primary-500 hover:brightness-100 ' +
			'focus:preset-filled-primary-500 focus:cursor-default active:preset-filled-primary-700 ' +
			'active:brightness-100 ' +
			'disabled:bg-primary-950 disabled:text-opacity-50 disabled:brightness-75 disabled:cursor-not-allowed py-5 ' +
      `${this.borderStyle} ` +
      (this.stretch ? 'w-full' : '');

			return this.toggled ? base + ' preset-filled-primary-500 cursor-default' : base;
		},
	},
});
</script>

<style scoped>

</style>
